<div class="main-div" fxLayout="row wrap">
    <div class="bodyClass">

        <div class="headers" style="display: inline;">
            <a  *ngIf="disableBack" href="/userProfiles/{{userId}}/setup/3"><img *ngIf="disableBack" src="assets\images\orange image.png" class="backArrow"></a>
            <h1 class="heading1">Connect with Community</h1>
          
                    <a href="/userProfiles/{{userId}}?home=false" class="skip"><button class="skipbtn" style="padding:1% 5%;"
                           appTrackClick
                        [buttonProps]="{
                            title:'setup_four_skip_button',
                            feature_context:'ONBOARDING'
                        }"
                        >Skip</button></a>

        </div>
        <p class="textClass"> Upload your own or use our <b> I Am Video</b> tool to create a fun-facts profile video
            like no other.
            <br>

        </p>
        <div class="container">

            <div class="container-info" style="border-right: 1px solid gray; height: 50vh;">
                <img src="assets\images\setup4.png" class="image" style="margin: 2%; width: 15vw;height:auto; border-radius: 5px;"><br>

                <p class="breakpara">Show the World Who You Are: <br> <b>Upload</b> Your Video
                </p>

                <div class="list">
                    <ol>
                        <li>Video length: 10-60 seconds</li>
                        <li>Accepted formats: mp4, m4v, mov</li>
                        <li>File size limit: 100 MB</li>
                    </ol>

                </div>



                <input class="form-control" type="file" (change)="onFileDetected($event)
                               " style="display: none"  accept="video/mp4,video/x-m4v,video/*" #file>
                <span>{{ title}}</span>
                <div>
                    <button type="button" style="background: white;
                     border: none;
                     color: blue;
                     text-decoration: underline;" (click)="showText()">
                             {{ isReadMore ? 'Read More': 'Read Less' }}
                         </button>
                         <p [ngClass]="isReadMore ? 'limitTextHeight': 'limitTextHeight2'" >
                            Share your unique personality with the community by
                            uploading a short video about yourself. Whether it's a quick selfie or a
                            creative masterpiece, we want to see what you love and what makes you,
                            well, you! Show us your passions, hobbies, or simply your amazing
                            personality.
                    </p>
                     </div>
                <button class="submitbtn"
                [ngClass]="isReadMore ? 'submitbtn' : 'submitbtn2'" [disabled]="disableSubmitBtn"  (click)="file.click()"
                   appTrackClick
                    [buttonProps]="{
                        title:'setup_four_upload_button',
                        feature_context:'ONBOARDING'
                    }"
                >Upload</button>

            </div>

            <div class="horizontal">
                <hr [ngClass]="isReadMore ? 'horizon' : 'horizon2'">
            </div>

            <div class="container-info1"[ngClass]="isReadMore ? 'container-info1' : 'container-info2'">

                <img src="assets\images\setup4(2).png" class="image"
                    style="margin: 2%; width: 15vw;height:auto;    border-radius: 5px;
                    "><br>
                <p class="breakpara1"><b>Create</b> a 30 second video <br> using our tool.</p>
                <!-- <div class="list" *ngIf="isReadMore"
            [ngClass]="{'limitMargin': isNetDivSmall}" >
             -->
                <div class="list">
                    <ol  *ngIf="isReadMore"
                    [ngClass]="{'limitMargin': isNetDivSmall}">
                        <li>Video length will be 30 seconds</li>
                        <li>Create your I am video </li>
                        <li class="accept">Accepted formats: mp4, m4v, mov </li>
                    </ol>

                    <ol  *ngIf="!isReadMore"
                    [ngClass]="{'limitMarginDiv': isNetDivSmall}">
                        <li>Video length will be 30 seconds</li>
                        <li>Create your I am video </li>
                        <li class="accept">Accepted formats: mp4, m4v, mov </li>
                    </ol>
                </div>

                <span style="font-size:10px;color:white">(Coming Soon)</span><br>

                <button class="submitbtn" (click)="navigateToIamvideo()" style=" margin: 5%;"
                   appTrackClick
                    [buttonProps]="{
                        title:'setup_four_create_button',
                        feature_context:'ONBOARDING'
                    }"    
                >Create</button>


            </div>

        </div>

    </div>

</div>
